const decoration = {
  line: "data-decoration-line"
};
const display = {
  default: "data-display"
};
const feature = {
  animation: "data-animation",
  lazyLoad: "data-lazy-load",
  imageExpand: "data-image-expand"
};
const loading = {
  priority: "data-loading-priority"
};
const feed = {
  type: "data-feed-type"
};
const information = {
  admissions: "data-admissions",
  alertUrl: "data-alert-url",
  events: "data-events",
  filterIds: "data-filter-group-ids",
  gift: "data-gift",
  id: "data-id",
  ids: "data-ids",
  mediaTrained: "data-media-trained",
  news: "data-news",
  removeIds: "data-remove-entry-ids",
  schools: "data-schools",
  search: "data-search",
  searchType: "data-search-type",
  title: "data-title",
  token: "data-token",
  url: "data-url"
};
const layout = {
  alertOff: "data-alert-off",
  alignment: "data-layout-alignment",
  columnCount: "data-layout-column-count",
  fixed: "data-layout-fixed",
  height: "data-layout-height",
  hidden: "data-layout-hidden",
  imageScaled: "data-layout-image-scaled",
  imagePosition: "data-layout-image-position",
  interior: "data-layout-interior",
  lock: "data-layout-lock",
  position: "data-layout-position",
  reverse: "data-layout-reverse",
  rowCount: "data-layout-row-count",
  spaceHorizontal: "data-layout-space-horizontal",
  text: "data-layout-text"
};
const sharing = {
  email: "data-email",
  print: "data-print"
};
const social = {
  facebook: "data-facebook",
  twitter: "data-twitter"
};
const theme = {
  default: "data-theme"
};
const visual = {
  bordered: "data-visual-bordered",
  campaign: "data-visual-campaign",
  imageAligned: "data-visual-image-aligned",
  icon: "data-visual-icon",
  iconSeal: "data-visual-icon-seal",
  hiddenDays: "data-days-to-hide",
  open: "data-visual-open",
  play: "data-visual-play",
  size: "data-visual-size",
  time: "data-visual-time",
  transparent: "data-visual-transparent"
};
const deprecated = {
  feature: {
    FULLSCREEN: "option-full-screen",
    SHOW_TIME: "show-time"
  },
  display: {
    DISPLAY_SIZE: "size",
    DISPLAY_TYPE: "display-type",
    DISPLAY: "display"
  },
  feed: {
    FEED_CATEGORIES: "categories",
    FEED_COLUMN_COUNT: "show-count",
    FEED_LAZY_LOAD: "lazyload",
    FEED_NOT_ENTRIES: "not",
    FEED_ROW_COUNT: "row-count",
    FEED_TOKEN: "token",
    FEED_UNION: "union"
  },
  option: {
    OPTIONAL_HAS_LINE: "has-line",
    OPTIONAL_HAS_SEPARATOR: "include-separator",
    OPTIONAL_STICKY_FIRST: "isStickyFirst"
  },
  layout: {
    DEFAULT: "layout",
    LAYOUT_FIXED: "fixed",
    LAYOUT_ALIGNMENT: "alignment",
    LAYOUT_IMAGE_POSITION: "image-position",
    LAYOUT_IMAGE_SCALED: "image-scaled",
    LAYOUT_STICKY_TOP: "position-top"
  },
  state: {
    RESIZE: "resize",
    STATE_DEPRECATD: "state",
    STATE: "data-state"
  },
  theme: {
    THEME_DEPRECATD: "theme"
  },
  type: {
    TYPE: "type",
    DATA_TYPE: "data-type"
  },
  visual: {
    VISUAL_ALIGN: "aligned",
    VISUAL_BORDER: "border",
    VISUAL_DAYS_TO_HIDE: "days-to-hide",
    VISUAL_HAS_LOGO: "hasLogo",
    VISUAL_ICON: "icon",
    VISUAL_TRANSPARENT: "transparent",
    VISUAL_QUOTE: "quote",
    VISUAL_TEXT_CENTER: "text-center",
    VISUAL_STYLE_PROPS: "styleProps"
  }
};
const AttributeNames = {
  decoration,
  display,
  feature,
  feed,
  information,
  layout,
  loading,
  sharing,
  social,
  theme,
  visual,
  deprecated
};
export {
  AttributeNames
};
//# sourceMappingURL=names.js.map
